module.exports = __webpack_public_path__ + "img/background3.4be70594.jpg";